// deal with old-style dcap time zone strings, e.g. EST5EDT4
// most js libs use 'America/New_York' not EST5EDT4 

const zoneData = [
    {
        name    : 'America/Los_Angeles',          // the unique identifier
        abbrs   : ['PDT', 'PST'],                 // the abbreviations
        offsets : [-420, -480]
    },
    {
        name    : 'America/Denver',
        abbrs   : ['MDT', 'MST'],
        offsets : [-360, -420]
    },
    {
        name    : 'America/Chicago',
        abbrs   : ['CDT', 'CST'],
        offsets : [-300, -360]
    },
    {
        name    : 'America/New_York',
        abbrs   : ['EDT', 'EST'],
        offsets : [-240, -300]
    },
    {
        name    : 'Pacific/Honolulu',
        abbrs   : ['HST'],
        offsets : [-600]
    },
    {
        name    : "America/Alaska",
        abbrs   : ['AKDT', 'AKST'],
        offsets : [-480, -540],
    },
    {
        name    : 'UTC',
        abbrs   : ['UTC'],
        offsets : [0]
    }   // keep this last
];

export function findTZ (tzAbbr) {
    if (typeof tzAbbr === 'undefined' || tzAbbr === null)
        return zoneData[zoneData.length-1]

        var tz = zoneData.find(zone => {
        return zone.abbrs.some(z => tzAbbr.includes(z))
    })
    return typeof tz === 'undefined' ? zoneData[zoneData.length-1] : tz;
}

export function mapTZAbbr (tzAbbr)
{
    const tz = findTZ (tzAbbr);
    return tz.name;
}

function mapTZOffset (dt, tzAbbr) {
    const tz = findTZ (tzAbbr);
    if (tz.offsets.length === 1) return tz.offsets[0];

    return isDstObserved(dt) ? tz.offsets[0] : tz.offsets[1];
}

export default function convertUTCToZoneTime (dt, tzAbbr) {
    var d = new Date (dt);
    const offset = mapTZOffset (d, tzAbbr);
    d.setTime(d.getTime() + offset * 60000);
    return d;
}

export function convertLocalToZoneTime (dt, tzAbbr) {
    var d = new Date(dt);
    d.setTime(d.getTime() + d.getTimezoneOffset()*60*1000);
    return convertUTCToZoneTime (d, tzAbbr); 
}

export function convertZoneToLocalTime (dt, tzAbbr) {
    var d = new Date(dt);
    const offset = mapTZOffset (dt, tzAbbr);
    d.setTime(d.getTime() - offset * 60000);
    return d;
}

export function UTCNow () {
    const d = new Date();
    d.setTime(d.getTime() + d.getTimezoneOffset()*60*1000);
    return d;
}

// this is kind of a hack. it uses browser time zones
function stdTimezoneOffset (dt) {
    var jan = new Date(dt.getFullYear(), 0, 1);
    var jul = new Date(dt.getFullYear(), 6, 1);
    return Math.max(jan.getTimezoneOffset(), jul.getTimezoneOffset());
}

function isDstObserved (dt) {
    return dt.getTimezoneOffset() < stdTimezoneOffset(dt);
}

export function SiteTimeNow(dcap_tz) {
    const d = UTCNow();
    const d1 = convertUTCToZoneTime(d, dcap_tz);
    return d1;
}

/* a few test cases...
var test1 = '2019-08-09 13:58:33';
console.log (convertToLocalTime(test1, "CST"))
console.log (convertToLocalTime(test1, 'MDT'))
console.log (convertToLocalTime(test1, 'PDT8PDT7'))
console.log (convertToLocalTime(test1, 'HST10'))
console.log (convertToLocalTime(test1, 'UTC'))

var today = new Date();
*/

/*if (isDstObserved(today, 'HST10')) { 
    alert ("Daylight saving time!");
}
else
    alert ("standard time")
*/